module.exports = __webpack_public_path__ + "img/5.2dddb7b6.jpg";